module.exports = __webpack_public_path__ + "static/antiberial-d791058ab8f6e8766d6e4e2bc4dc5eed.jpg";